import React from "react";
import { useNavigate } from "react-router-dom";
import "./home.css"; // optional if you want to style

function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      <h1>Welcome to ChapterOne 🎓</h1>
      <p className="home-tagline">
        Your entry-level career starts here—with intent, not endless clicking.
      </p>

      <div className="home-philosophy">
        <p className="home-philosophy-label">Five applications per day</p>
        <p className="home-philosophy-lead">
          ChapterOne caps you at <strong>five applications each day</strong> on
          purpose. That limit keeps the focus on roles you have actually read
          and chosen, so every send feels considered instead of copied and
          pasted everywhere.
        </p>
        <p className="home-philosophy-body">
          Make it a routine: visit often, use your five slots wisely, and come
          back tomorrow. Showing up every day builds the persistence and
          dedication that carry a real job search—this board is built around
          that rhythm.
        </p>
      </div>

      <div className="home-buttons">
        <button onClick={() => navigate("/sign-in")}>Sign In</button>
        <button onClick={() => navigate("/sign-up")}>Create Account</button>
        <button onClick={() => navigate("/blog")}>Read the Blog</button>
      </div>

      <div className="job-board-section">
        <h2>🚀 Find Your First Job!</h2>
        <p>Browse hundreds of entry-level positions in California</p>
        <p>
          <strong>No experience required!</strong>
        </p>
        <button className="job-board-button" onClick={() => navigate("/")}>
          Browse Entry-Level Jobs →
        </button>
      </div>
    </div>
  );
}

export default Home;
